import { mixins, styled } from '@pulse-web-ui/theme';

export const StyledCheckboxContainer = styled.div<{
  gridStep?: number;
  marginBottom?: number;
}>`
  ${(props) => mixins.flex({ horizontal: false, gap: props.gridStep || 20 })}
  margin-bottom: ${(props) => props.marginBottom || 0};
`;
